import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

const useGetTrainingSet = (trainingSetId: string, enabled: boolean = true, dpid?: string) => {
  const glynt = useGlynt(dpid);

  return useQuery({
    queryKey: ['trainingSet', trainingSetId],
    queryFn: async () => await (await glynt).trainingSet.retrieve(trainingSetId),

    enabled:
      enabled && !!trainingSetId && trainingSetId !== 'unclassified' && trainingSetId.length > 0
  });
};

export default useGetTrainingSet;
